import React                       from 'react';
import { Col }                     from 'antd';
import { observer }                from 'mobx-react';
import { ApiCollection }           from 'collections/ApiCollection';
import { ROLE_STANDIST_DECORATOR } from 'constants/StandistRoleReference';
import { ROLE_STANDIST_EXHIBITOR } from 'constants/StandistRoleReference';
import { MODE_ADD_FOR_EXHIBITOR }  from 'forms/StandistForm/StandistForm';
import StandistForm                from 'forms/StandistForm/StandistForm';
import DemandConfigModel           from 'models/DemandConfigModel';
import DemandTypeModel             from 'models/DemandTypeModel';
import UserStandRoleModel          from 'models/UserStandRoleModel';
import { standDashboardStore }     from 'stores/index';
import { navigationStore }         from 'stores/NavigationStore';
import currentSession              from 'utils/currentSession';
import rights                      from 'utils/rights';
import Row                         from 'components/App/Row';
import handleApiError              from 'utils/handleApiError';
import modalConfirmDelete          from 'utils/modalConfirmDelete';
import RedButton                   from 'components/App/RedButton';
import InformationsDates           from './InformationsDates';
import AppDownloadBtn              from 'components/App/AppDownloadBtn';
import DemandExemptionForm         from 'forms/DemandExemptionForm';
import DemandLogisticForm          from 'forms/DemandLogisticForm';
import DemandModel                 from 'models/DemandModel';
import DemandLogisticModel         from 'models/DemandLogisticModel';
import CardBox                     from 'components/App/CardBox';
import FormattedMessageWrapper     from 'components/App/FormattedMessageWrapper';
import DemandLogisticMediaModel    from 'models/DemandLogisticMediaModel';
import { EXEMPTION_DELIVERY }      from 'constants/DemandTypes';
import { EXEMPTION_DISMANTLING }   from 'constants/DemandTypes';
import { EXEMPTION_MOUNTING }      from 'constants/DemandTypes';
import { LOGISTIC_MATERIAL }       from 'constants/DemandTypes';
import { LOGISTIC_VEHICLE }        from 'constants/DemandTypes';
import Space                       from 'components/App/Space';
import UserModel                   from 'models/UserModel';
import MountingAttestationModel    from 'models/MountingAttestationModel';
import { AppForm }                 from 'components/App/AppForm';
import MountingAttestationForm     from 'forms/MountingAttestationForm';
import BlueButton                  from 'components/App/BlueButton';

import defaultLogoUrl from '/images/default-logo.png?url';

@observer
class Content extends React.Component {

  public render() {
    const {
      collDemandConfig: demandConfigCollection,
      collDemandType: demandTypeCollection,
      collMountingAttestation,
      collUserStandRole,
      show,
      stand,
    } = standDashboardStore;

    const demandConfigsExemption: any[] = [];
    const demandConfigsLogistic: any[] = [];

    demandConfigCollection.forEach((demandConfig: DemandConfigModel) => {
      if (demandConfig.surfaceMin > parseFloat(stand.surface.replace(/,/g, '.'))) {
        return;
      }

      const dType = demandTypeCollection.findBy('@id', demandConfig.demandType) as DemandTypeModel;

      if (!dType) {
        return;
      }

      if (
        [EXEMPTION_MOUNTING, EXEMPTION_DISMANTLING, EXEMPTION_DELIVERY].find(
          dTypeReference => dTypeReference === dType.reference,
        )
      ) {
        demandConfigsExemption.push(demandConfig);
      } else if (
        [LOGISTIC_VEHICLE, LOGISTIC_MATERIAL].find(
          dTypeReference => dTypeReference === dType.reference,
        )
      ) {
        demandConfigsLogistic.push(demandConfig);
      }
    });

    const mountingAttestation: MountingAttestationModel = collMountingAttestation.first() as MountingAttestationModel || new MountingAttestationModel();

    const currentUserIsExhibitorOrDecorator = !!collUserStandRole.find(
      (usr: UserStandRoleModel) => usr.userIri === `/backend/users/${currentSession.user.user_id}`
        && (usr.standistRole === ROLE_STANDIST_EXHIBITOR || usr.standistRole === ROLE_STANDIST_DECORATOR)
    );

    return (
      <>
        <Row>
          <Col md={14} sm={24}>
            <Space size={12}>
              <Row>
                <Col md={12} sm={24}>
                  {show.isLoaded && (
                    <img
                      alt="logo"
                      className="stand-show-logo"
                      src={show.logoObjectUrl || defaultLogoUrl}
                    />
                  )}
                </Col>
                <Col md={12} sm={24}>
                  <ul id="documents-list">
                    <li>
                      {show.exhibitorGuideObjectUrl && (
                        <AppDownloadBtn
                          filename={show.exhibitorGuideMediaFileName}
                          link={show.exhibitorGuideObjectUrl}
                          text={<FormattedMessageWrapper id="Télécharger le règlement" />}
                        />
                      )}
                    </li>
                    <li>
                      {!!show.mapObjectUrl && (
                        <AppDownloadBtn
                          filename={show.mapMediaFileName}
                          link={show.mapObjectUrl}
                          text={<FormattedMessageWrapper id="Télécharger les informations !" />}
                        />
                      )}
                    </li>
                    <li>
                      {!!show.securityInstructionsOption &&
                        show.securityInstructionsObjectUrl && (
                        <AppDownloadBtn
                          filename={show.securityInstructionsMediaFileName}
                          link={show.securityInstructionsObjectUrl}
                          text={<FormattedMessageWrapper id="Télécharger les consignes de sécurité" />}
                        />
                      )}
                    </li>
                  </ul>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 12,
                    }}
                  >
                    {!!demandConfigsExemption.length && (
                      <BlueButton
                        onClick={() => AppForm.open(DemandExemptionForm, {
                          demandConfigs: demandConfigsExemption,
                          model: new DemandModel(),
                          onSuccess: (demand: DemandModel) => {
                            navigationStore.push(`/demandes/${demand.id}`);
                          },
                          stand,
                        }, {
                          okText: <FormattedMessageWrapper id="Enregistrer" />,
                          title: <FormattedMessageWrapper id="Nouvelle demande de dérogation" />,
                        })}
                        type="default"
                      >
                        <FormattedMessageWrapper id="Demande de dérogation" />
                      </BlueButton>
                    )}

                    {!!demandConfigsLogistic.length && (
                      <BlueButton
                        onClick={() => AppForm.open(DemandLogisticForm, {
                          demandConfigs: demandConfigsLogistic,
                          demandLogistic: new DemandLogisticModel(),
                          demandLogisticMediaDocument: new DemandLogisticMediaModel(),
                          demandLogisticMediaPlan: new DemandLogisticMediaModel(),
                          model: new DemandModel(),
                          onSuccess: (demand: DemandModel) => {
                            navigationStore.push(`/demandes/${demand.id}`);
                          },
                          stand,
                        }, {
                          okText: <FormattedMessageWrapper id="Enregistrer" />,
                          title: <FormattedMessageWrapper id="Nouvelle demande de logistique" />,
                          width: 1024,
                        })}
                        type="default"
                      >
                        <FormattedMessageWrapper id="Demande de logistique" />
                      </BlueButton>
                    )}

                    {!!show.standDocumentsOption && (
                      <BlueButton
                        onClick={() => {
                          navigationStore.push(`/stands/${stand.id}/documents`);
                        }}
                        type="default"
                      >
                        <FormattedMessageWrapper id="Documents" />
                      </BlueButton>
                    )}

                    {(
                      rights.for.userStandRole.add
                      && currentUserIsExhibitorOrDecorator
                      && !!show.standAddDecoratorOption
                    ) && (
                      <BlueButton
                        onClick={() => {
                          this.openStandistFormModal();
                        }}
                        type="default"
                      >
                        <FormattedMessageWrapper id="Enregistrer mon décorateur" />
                      </BlueButton>
                    )}

                    {(
                      rights.for.mountingAttestation.add
                      && !!show.mountingAttestationOption
                      && mountingAttestation.status === 'completed'
                    ) && (
                      <RedButton
                        onClick={() => {
                          modalConfirmDelete({
                            onOk: async () => {
                              try {
                                await mountingAttestation.destroy();
                                await standDashboardStore.collDocument.list();
                              } catch (error: any) {
                                handleApiError(error);
                              }
                            }
                          });
                        }}
                        type="default"
                      >
                        <FormattedMessageWrapper id="Supprimer l'attestation de bon montage" />
                      </RedButton>
                    )}

                    {(
                      rights.for.mountingAttestation.add
                      && !!show.mountingAttestationOption
                      && mountingAttestation.status !== 'completed'
                    ) && (
                      <BlueButton
                        onClick={() => {
                          AppForm.open(MountingAttestationForm, {
                            model: mountingAttestation,
                            onSuccess: () => {
                              standDashboardStore.collMountingAttestation.list();
                              standDashboardStore.collDocument.list();
                            },
                            stand: stand,
                          }, {
                            title: <FormattedMessageWrapper id="Attestation de bon montage" />,
                            width: 1024,
                          });
                        }}
                        type="default"
                      >
                        <FormattedMessageWrapper id="Remplir l'attestation de bon montage" />
                      </BlueButton>
                    )}
                  </div>
                </Col>
              </Row>
            </Space>
          </Col>
          <Col md={10} sm={24}>
            <InformationsDates show={show} />
          </Col>
        </Row>
      </>
    );
  }

  private openStandistFormModal = () => {
    AppForm.open(
      StandistForm,
      {
        mode: MODE_ADD_FOR_EXHIBITOR,
        onSuccess: () => {
          standDashboardStore.fetchRoleCollectionAndStandistsData(standDashboardStore.stand.id);
        },
        stand: standDashboardStore.stand,
        standistCollection: new ApiCollection(UserModel),
        standistRole: ROLE_STANDIST_DECORATOR,
        user: new UserModel(),
        userStandRole: new UserStandRoleModel(),
      },
      {
        title: <FormattedMessageWrapper id="Enregistrer mon décorateur" />,
        width: 1024,
      },
    );
  };
}

interface StandDashboardShowBoxProps {
  isLoading: boolean;
}

const StandDashboardShowBox = ({
  isLoading,
}: StandDashboardShowBoxProps) => (
  <div id="stand-informations">
    <CardBox
      content={
        <Content />
      }
      loading={isLoading}
      title={standDashboardStore.show.showName}
    />
  </div>
);

export default StandDashboardShowBox;
